import JobFileCard from './JobFileCard';
import JobFileCards from './JobFileCards';

export {
  JobFileCard,
  JobFileCards,
}



// WEBPACK FOOTER //
// ./src/components/admin/Jobs/Files/index.js